"use client";
//#region packages/@mantine/core/src/components/Transition/get-transition-props/get-transition-props.ts
const defaultTransition = {
	duration: 100,
	transition: "fade"
};
function getTransitionProps(transitionProps, componentTransition) {
	return {
		...defaultTransition,
		...componentTransition,
		...transitionProps
	};
}
//#endregion
export { getTransitionProps };

//# sourceMappingURL=get-transition-props.mjs.map